import React from 'react';
import { Currency } from 'ui-toolkit';
import { SpaEscrowBalancesHeader } from './SpaEscrowBalancesHeader';
import { IEscrowBalancesData } from '../../../../../types/order/escrow/data/IEscrowBalancesData';
import { IEscrowFormData } from '../../../../../types/order/escrow/state/IEscrowFormData';

export interface IEscrowBalancesHeaderContainerProps {
  escrowBalancesHeaderSlice: IEscrowBalancesData;
  escrowFormDataSlice: IEscrowFormData;
}

export const SpaEscrowBalancesHeaderContainer: React.FC<IEscrowBalancesHeaderContainerProps> = ({
  escrowBalancesHeaderSlice,
  escrowFormDataSlice,
}) => {
  const { actualAmountDollarsMismatchedFiltered, availableAmountDollarsMismatchedFiltered } = escrowBalancesHeaderSlice;

  const displayActualAmount: number = actualAmountDollarsMismatchedFiltered;
  const displayAvailableAmount: number = availableAmountDollarsMismatchedFiltered;
  const displayTotalAmount: number = escrowBalancesHeaderSlice.depositsTotalAmountDollarsMismatchedFiltered;

  const depositsTotalAmountDollars =
    displayTotalAmount +
    escrowFormDataSlice.currentDeposits.reduce((p, c) => p + c, 0) -
    escrowFormDataSlice.originalDeposits.reduce((p, c) => p + c, 0);
  const disbursementsTotalAmountDollars =
    escrowBalancesHeaderSlice.disbursementsTotalAmountDollars +
    escrowFormDataSlice.currentDisbursements.reduce((p, c) => p + c, 0) -
    escrowFormDataSlice.originalDisbursements.reduce((p, c) => p + c, 0);

  return (
    <SpaEscrowBalancesHeader
      actual={(displayActualAmount && <Currency value={displayActualAmount} />) || '--'}
      available={(displayAvailableAmount && <Currency value={displayAvailableAmount} />) || '--'}
      totalDeposits={(depositsTotalAmountDollars && <Currency value={depositsTotalAmountDollars} />) || '--'}
      totalDisbursements={
        (disbursementsTotalAmountDollars && <Currency value={disbursementsTotalAmountDollars} />) || '--'
      }
    />
  );
};
